"use client";

import type { OddsDisplay } from "@/lib/odds-screen/live/types";
import { storedChoice } from "./stored-choice";

const DEFAULT: OddsDisplay = "american";
const SUPPORTED: readonly OddsDisplay[] = ["american", "decimal", "percent"];

function isOddsDisplay(value: string | null): value is OddsDisplay {
  return value !== null && (SUPPORTED as readonly string[]).includes(value);
}

const useStoredFormat = storedChoice<OddsDisplay>("odds-screen:oddsDisplay", (raw) => (isOddsDisplay(raw) ? raw : DEFAULT), DEFAULT);

export function useOddsDisplay(): { format: OddsDisplay; setFormat: (next: OddsDisplay) => void } {
  const [format, setFormat] = useStoredFormat();
  return { format, setFormat };
}
